<!-- ========== Left Sidebar Start ========== -->

<ng-template #contentTemplate>

  <!--- Sidemenu -->
  <div id="sidebar-menu">
    <!-- Left Menu Start -->
    <ul class="metismenu list-unstyled" id="side-menu" #sideMenu>
      <!-- {{menuItems}} -->
      @for (item of menuItems; track $index) {
      <ng-container>
        @if(item.isTitle){
        <li class="menu-title">{{ item.label | translate }}</li>
        }@else if(!item.isTitle && !item.isLayout){
        <li>
          @if(hasItems(item)){
          <a href="#" (click)="$event.preventDefault()" class="is-parent" [ngClass]="{'has-arrow': !item.badge, 'has-dropdown': item.badge}">
            @if(item.icon){
            <i class="bx {{item.icon}}"></i>
            }
            <span> {{ item.label | translate }}</span>
            @if(item.badge){
            <span class="badge rounded-pill float-end bg-{{item.badge.variant}}">{{item.badge.text |
              translate}}</span>
            }
          </a>}
          @else{
          <a routerLink="{{item.link}}" class="side-nav-link-ref" routerLinkActive="active">
            @if(item.icon){
            <i class="bx {{ item.icon }}"></i>
            }
            <span> {{ item.label | translate }}</span>
            @if(item.badge){
            <span class="badge rounded-pill bg-{{item.badge.variant}} float-end">{{item.badge.text |
              translate}}</span>
            }
            <!-- Live unread count, kept out of the shared MENU constant so the
                 count cannot leak between organisations. -->
            @if(item.link === 'conversations' && unreadConversationCount > 0){
            <span class="badge rounded-pill bg-danger float-end">{{ unreadConversationCount }}</span>
            }
          </a>
          }
          @if(hasItems(item)){
          <ul class="sub-menu" aria-expanded="false">
            @for (subitem of item.subItems; track $index) {
            <li>
              @if(hasItems(subitem)){
              <a class="side-nav-link-a-ref has-arrow" href="#" (click)="$event.preventDefault()" [attr.data-parent]="subitem.parentId">
                {{ subitem.label | translate}}
              </a>
              <ul class="sub-menu mm-collapse" aria-expanded="false">
                @for (subSubitem of subitem.subItems; track $index) {
                <li>
                  <a [attr.data-parent]="subSubitem.parentId" routerLink="{{subSubitem.link}}" routerLinkActive="active" class="side-nav-link-ref">
                    {{ subSubitem.label | translate }}
                  </a>
                </li>
                }
              </ul>}
              @else{
              <a routerLink="{{subitem.link}}" class="side-nav-link-ref" [attr.data-parent]="subitem.parentId" routerLinkActive="active">
                {{ subitem.label | translate}}
                @if(subitem.badge){
                <span class="badge rounded-pill bg-{{subitem.badge.variant}} float-end">{{subitem.badge.text |
                  translate}}</span>
                }
              </a>
              }
            </li>
            }
          </ul>
          }
        </li>
        }
      </ng-container>
      }
    </ul>
  </div>
</ng-template>
<!-- Sidebar -->

<div class="vertical-menu">
  <ngx-simplebar class="h-100" #componentRef>
    @if(isCondensed){
    <div>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    }@else {
    <div>
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    }
    
    <!-- Customer Feedback Button -->
    <div class="sidebar-feedback">
      <button class="btn btn-primary btn-block w-100" (click)="openFeedbackForm()">
        <i class="bx bx-message-dots me-2"></i>Send Feedback
      </button>
    </div>
  </ngx-simplebar>
</div>
<!-- Left Sidebar End -->